var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEsg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 24,
    fill: "#EEF6FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 49L44.5 37L51.5 44L65.5 30M65.5 30V36.5M65.5 30H59M61.5 47V66M52 56.5V66M42.5 51.5V66M33 58.5V66",
    stroke: "#008CB7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsg6);
export default __webpack_public_path__ + "static/media/esg6.1c0ec654147bbb35666c34ce0e0a90d2.svg";
export { ForwardRef as ReactComponent };